// extracted by mini-css-extract-plugin
export default {"resources":"WeekAccordion_resources__jXjYu","resources_wrapper":"WeekAccordion_resources_wrapper__nVnAN","weeksList":"WeekAccordion_weeksList__oYp0c"};